const BlogDetail = ({ isOpen, onClose, blog }) => {
  return (
    <div className="modal-overlay">
      <div style={{ width: "60vw", height: "50vw" }} className="modal-content">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
        <h2>{blog.title}</h2>
        <div className="detailmodal-body">
          <img style={{marginInline:"auto",width:"16vw",height:"16vw"}} src={blog.headerImageUrl} />
          <h2>{blog.titleDesc}</h2>
          <h2>{blog.description}</h2>
        </div>
      </div>
    </div>
  );
};


export default BlogDetail;
